import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface DefaultPrivacies {
  entry: number
  reply: number
  upload: number
  tagset: number
}

interface DefaultsState {
  defaults: DefaultPrivacies
  setDefaults: (d: DefaultPrivacies) => void
}

export const useDefaultsStore = create<DefaultsState>()(
  persist(
    (set) => ({
      defaults: { entry: 0, reply: 0, upload: 0, tagset: 0 },
      setDefaults: (defaults) => set({ defaults }),
    }),
    { name: 'abaddon-defaults' }
  )
)
